import lang from 'dojo/_base/lang';
import cookie from 'dojo/cookie';

import Mediator from 'gisw/Classes/Mediator';
import { html } from 'gisw/Helpers/html';
import NodeHash from 'gisw/Widgets/NodeHash';

// @ts-ignore
window.lastButtonPressed = '';  // global variable

class CenterMenu {
  /**
   * @param {object} config
   * @param {string} config.id
   * @param {string} config.display
   */
  constructor (config) {
    this.display = config.display;
    this.id = config.id;

    this.tabSelectList = document.createElement('select');
    this.tabSelectList.id = 'tabsSelect';

    /** @type {Record<string, number>} */
    this.optionNameToIndex = {};
    /** @type {Array<HTMLButtonElement>} */
    this.menuButtons = [];
    /** @type {Record<string, HTMLButtonElement>} */
    this.menuBtns = {};
    /** @type {HTMLButtonElement} */
    this.selectBtn = null;

    /** @type {HTMLDivElement} */
    this.domNode = document.body.querySelector('#centerMenu');
    /** @private @type {HTMLDivElement} */
    this.countyName = document.body.querySelector('#countyName');
    /** @private @type {HTMLDivElement} */
    this.tabContainer = document.body.querySelector('#tabsInnerContainer');
    /** @private @type {HTMLDivElement} */
    this.tabSelect = document.body.querySelector('#tabSelectContainer');
    /** @type {HTMLDivElement} */
    this.toolsSecondary = document.body.querySelector(
      '#toolsContainerSecondary'
    );
    /** @private @type {HTMLDivElement} */
    this.searchContainer = document.body.querySelector('#searchContainerMain');
    /** @type {HTMLDivElement} */
    this.toolsMain = document.body.querySelector('#toolsContainerMain');
    /** @private @type {HTMLDivElement} */
    this.navToolMain = document.body.querySelector('#navigationToolMain');

    this.postCreate();
  }

  postCreate () {
    this.defaultTabs = Mediator.serverData.defaultTabs;

    this.tabsBtnsGridWidget = getTabMenuNodeHash(this, getInitTabsToItems());
    this.tabsBtnsGridWidget.itemEventListener(
      'click',
      this.buttonHandler.bind(this),
      this,
      300
    );

    this.setDisplayNameAndLogo();

    // @ts-ignore
    // Set in Views/Shared/Layout.cshtml
    window.setTabContainerWidth();

    window.addEventListener('resize', () => {
      if (Mediator.serverData.EntityNameDisplayType === 'BelowToolbar') {
        this.searchContainer.prepend(this.displayNameLabel);
      }

      // @ts-ignore
      window.setTabContainerWidth();
    });

    // Empty the tabContainer before adding new buttons
    this.tabContainer.innerHTML = '';

    for (let i = 0; i < this.menuButtons.length; i++) {
      const currentMenuBtn = this.menuButtons[i];

      if (i === 0) {
        currentMenuBtn.classList.add('first');
      }

      if (i === this.menuButtons.length - 1) {
        currentMenuBtn.classList.add('last');
      }

      this.tabContainer.appendChild(currentMenuBtn);

      if (currentMenuBtn.classList.contains('disabled')) {
        continue;
      }

      const inner = currentMenuBtn.innerHTML.replace('<br>', ' ').trim();

      this.tabSelectList.appendChild(
        html`<option value="${inner}">${inner}</option>`.item(0)
      );

      this.optionNameToIndex[Mediator.getTabNameByLabel(inner)] = i;
    }

    this.tabSelect.appendChild(this.tabSelectList);

    $('.tabListItems').on('click', event => {
      const element = event.target;
      const roadsTabLink = Mediator.serverData.FrontEndOption['RoadsTabLink'];

      // Open the SimpleRoads site when the Roads tab is clicked
      if (element.id === 'RoadsBtn' &&
        typeof roadsTabLink !== 'undefined' &&
        roadsTabLink !== null
      ) {
        window.open(roadsTabLink.Value, '_blank');
      }

      if (!element.classList.contains('disabled')) {
        this.buttonHandler(element, element.title);
      }
    });

    this.tabSelectList.addEventListener('change', () => {
      this.buttonHandler(this.tabSelectList, this.tabSelectList.value);
    });
  }

  setDisplayNameAndLogo () {
    // use state full name
    const displayName = Mediator.serverData.displayName;
    const stateName = Mediator.serverData.StateFull;

    // website title is County name + State full name
    const siteNameDiv = document.getElementById('displayName');

    const isBelowToolbar =
      Mediator.serverData.EntityNameDisplayType === 'BelowToolbar';
    const currentInnerHtml = this.getDisplayName(displayName, stateName);
    const classNameTobeAdded = isBelowToolbar ? 'below-toolbar' : '';

    const parentElement = isBelowToolbar ? this.searchContainer : siteNameDiv;

    if (document.getElementById('displayNameLabel')) {
      document.getElementById('displayNameLabel').remove();
    }

    /** @private @type {HTMLDivElement} */
    // @ts-ignore
    this.displayNameLabel = html`<div
      id="displayNameLabel"
      class="${classNameTobeAdded}"
    >
      ${currentInnerHtml}
    </div>`.item(0);
    parentElement.prepend(this.displayNameLabel);
  }

  copyTools () {
    const from = Mediator.leftPanel.getGWindow('tools')?.domNode;

    if (!from) {
      return;
    }

    /** @type {NodeListOf<HTMLDivElement>} */
    const tools = from.querySelectorAll('.ThumbnailGrid');

    if (document.getElementById('toolsContainer')) {
      document.getElementById('toolsContainer').remove();
    }

    const regTools = document.createElement('div');
    regTools.id = 'toolsContainer';

    if (document.getElementById('navToolsContainer')) {
      document.getElementById('navToolsContainer').remove();
    }

    const navTools = document.createElement('div');
    navTools.id = 'navToolsContainer';
    this.navToolMain.appendChild(navTools);

    for (let i = 0; i < tools.length; i++) {
      let toolName = tools[i].children[0].id;
      toolName = toolName.substring(0, toolName.length - 3);

      const color = Mediator.toolsManager.getToolColor(toolName);

      if (color === 'blue') {
        navTools.appendChild(lang.clone(tools[i]));
      } else {
        regTools.appendChild(lang.clone(tools[i]));
      }
    }

    // Store tools in main and secondary containers.
    // Only showing one at a time

    this.toolsMain.innerHTML = '';
    this.toolsMain.appendChild(lang.clone(regTools));

    this.toolsSecondary.innerHTML = '';
    this.toolsSecondary.appendChild(lang.clone(regTools));
  }

  /**
   * @param {*} domNode
   * @param {string} btnNameInput
   */
  buttonHandler (domNode, btnNameInput) {
    let tabLabel = btnNameInput.replace('<br>', ' ');
    // @ts-ignore
    window.lastButtonPressed = tabLabel;

      // This handler fires after
    if (tabLabel === 'Planning/Zoning') {
      tabLabel = 'PlanningZoning';
    }

    if (
      tabLabel === 'Emergency Mgmt.' ||
      tabLabel === 'Emergency Management' ||
      tabLabel === 'Emergency Mgmt'
    ) {
      tabLabel = 'EM';
    }

    const tabName = Mediator.getTabNameByLabel(tabLabel);
    _toggleSelectBtnCSS(this, tabName);
    this.currentTabName = tabName;

    // Save startup_tab
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);

    cookie('startup_tab', tabName, { expires: expirationDate.toUTCString() });

    Mediator.handle({
      name: 'centerMenu.tab.click',
      args: [{ name: tabName }]
    });

    Mediator.currentTab = tabName;

    // If the user gets to the tab in the URL
    // Don't take them back there on every login/logout
    if (tabLabel === Mediator.serverData.tabNameInURL) {
      Mediator.ignoreURLTab = true;
    }
  }

  /**
   * @param {string} name
   */
  setSelectListValue (name) {
    this.tabSelectList.value = name;
  }

  setInitialTab () {
    this.buttonHandler(null, Mediator.getCurrentTabName());
  }

  /**
   * @param {string} displayName
   * @param {string} stateName
   */
  // eslint-disable-next-line class-methods-use-this
  getDisplayName (displayName, stateName) {
    if (
      Mediator.serverData.FrontEndOption['HideDisplayName'] ||
      Mediator.serverData.EntityNameDisplayType === 'None'
    ) {
      return '';
    }

    let entityDisplayName = '';

    if (
      Mediator.serverData.FrontEndOption['noBreakInDisplayName'] ||
      Mediator.serverData.EntityNameDisplayType === 'BelowToolbar'
    ) {
      entityDisplayName = displayName + ' ' + stateName;
    } else {
      entityDisplayName = displayName + '<br>' + stateName;
    }

    return entityDisplayName;
  }
}

/**
 * @param {CenterMenu} tw
 * @param {Array<{ key: string; enabled: boolean; }>} initItems
 */
function getTabMenuNodeHash (tw, initItems) {
  const nodeHash = new NodeHash({
    initItems,
    className: 'ThumbnailWindow',
    createNode (param) {
      /** @type {HTMLButtonElement} */
      let button;
      let title = Mediator.ToolsTitleDiscription[param.key]
        ? Mediator.ToolsTitleDiscription[param.key]
        : param.key;

      // Get the tab label
      title = Mediator.serverData.TabLabel[title];

      if (!title) {
        title = param.key;
      }

      if (param.enabled) {
        // @ts-ignore
        button = html`<button
          id="${param.key}Btn"
          class="tabListItems"
          type="button"
        >
          ${title.replace(' ', '<br/>')}
        </button>`.item(0);
      } else {
        // @ts-ignore
        button = html`<button
          id="${param.key}Btn"
          class="tabListItems disabled"
          type="button"
          disabled
        >
          ${title}
        </button>`.item(0);
      }

      tw.menuButtons.push(button);

      if (!tw.menuBtns) {
        tw.menuBtns = {};
      }

      tw.menuBtns[param.key] = button;
      return button;
    }
  });
  addGridBtnsToAttachPoints(nodeHash);
  tw.nodeHash = nodeHash;

  return nodeHash;
}

/**
 * @param {NodeHash} nodeHash
 */
function addGridBtnsToAttachPoints (nodeHash) {
  if (!nodeHash) {
    return;
  }

  /** @type {NodeListOf<HTMLDivElement>} */
  const btnsGrid = nodeHash.domNode.querySelectorAll('.GridMenu');

  for (let i = 0; i < btnsGrid.length; i++) {
    nodeHash[btnsGrid[i].id] = btnsGrid[i];
  }
}

function getInitTabsToItems () {
  const tabs = Mediator.serverData.Tabs;
  const defaultTabs = Mediator.serverData.defaultTabs;
  const initItems = [];

  if (tabs) {
    for (let i = 0; i < defaultTabs.length; i++) {
      if (!defaultTabs[i]) {
        continue;
      }

      initItems.push({
        key: defaultTabs[i],
        enabled: buttonExists(defaultTabs[i], tabs)
      });
    }
  }

  return initItems;
}

/**
 * @param {string} buttonName
 * @param {string[]} tabs
 */
function buttonExists (buttonName, tabs) {
  let btnName = buttonName;

  if (btnName === 'Emergency Management') {
    btnName = 'EM';
  }

  return tabs.some(tab => tab === btnName);
}

/**
 * @param {CenterMenu} tw
 * @param {string} toolName
 */
function _toggleSelectBtnCSS (tw, toolName) {
  if (tw.selectBtn) {
    tw.selectBtn.classList.remove('selected');
  }

  tw.selectBtn = tw.menuBtns[toolName];

  if (tw.selectBtn) {
    tw.selectBtn.classList.add('selected');
  }
}

export default CenterMenu;
